function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Atency");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M202.84,63.79A30.57,30.57,0,0,0,176,33.45L91.89,17.88A30.59,30.59,0,0,0,54,47.57v76.65a1.18,1.18,0,0,0,1.18,1.18H87.62a1.18,1.18,0,0,0,1.18-1.18V52.7L168,67.37V90.6H126.19A1.18,1.18,0,0,0,125,91.77v32.45a1.18,1.18,0,0,0,1.18,1.18h75.48a1.18,1.18,0,0,0,1.18-1.18Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M315.62,125.35a1.85,1.85,0,0,1-1.67-1l-12-21.83H254.25l-12,21.83a1.85,1.85,0,0,1-1.67,1c-1.42,0-2.08-.56-2.08-1.72q0-.61,17.37-32.41,17.32-31.6,20.31-36.51a2.2,2.2,0,0,1,1.87-1.27,2.28,2.28,0,0,1,2,1.27C282,58,288.78,70.16,300.33,91.22q17.4,31.83,17.37,32.41C317.7,124.8,317,125.35,315.62,125.35ZM300,99,278.15,59.17,256.22,99Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M360.85,57H337.76v66.59c0,1.16-.66,1.77-2,1.77s-1.92-.61-1.92-1.77V57H310.77c-1.32,0-2-.61-2-1.77s.66-1.77,2-1.77h50.08c1.32,0,2,.61,2,1.77S362.17,57,360.85,57Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M414.88,125.35H373.16c-1.32,0-2-.61-2-1.77V55.22c0-1.16.66-1.77,2-1.77h41.73c1.32,0,2,.61,2,1.77s-.66,1.77-2,1.77h-39.8V87.63h31.5c1.27,0,1.92.61,1.92,1.77s-.66,1.77-1.92,1.77h-31.5v30.64h39.8c1.32,0,2,.61,2,1.77S416.2,125.35,414.88,125.35Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M490.44,123.58c0,1.16-.66,1.77-2,1.77a2.35,2.35,0,0,1-1.72-.91L432,60.38v63.2c0,1.16-.66,1.77-1.92,1.77s-2-.61-2-1.77L428,55.22c0-1.16.66-1.77,2-1.77a2.34,2.34,0,0,1,1.72.91l54.79,64.06V55.22c0-1.16.66-1.77,2-1.77s1.92.61,1.92,1.77Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M569.09,114.82q-11.09,10.56-28,10.53c-10.94,0-20.21-3.49-28-10.53s-11.6-15.5-11.6-25.42S505.43,71,513.18,64s17-10.53,28-10.53q16.86,0,28,10.53a1.58,1.58,0,0,1,.61,1.22q0,1.82-2,1.82a2.53,2.53,0,0,1-1.42-.56Q554.23,57,541.13,57a36.1,36.1,0,0,0-25.22,9.52c-7,6.33-10.43,13.93-10.43,22.89s3.44,16.61,10.43,22.94,15.34,9.47,25.22,9.47q13.06,0,25.17-9.47a2.53,2.53,0,0,1,1.42-.56q2,0,2,1.82A1.58,1.58,0,0,1,569.09,114.82Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M637.25,56.28,608.49,90v33.57c0,1.16-.71,1.77-2,1.77s-1.92-.61-1.92-1.77V90L575.72,56.28a1.64,1.64,0,0,1-.46-1.06c0-1.22.66-1.82,2-1.82a1.71,1.71,0,0,1,1.47.76l27.75,32.36,27.7-32.36a1.71,1.71,0,0,1,1.47-.76c1.37,0,2,.61,2,1.82A1.64,1.64,0,0,1,637.25,56.28Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 687 146",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.d468f70b.svg";
export { ForwardRef as ReactComponent };